import { FaLightbulb, FaHandshake, FaAward, FaShieldAlt, FaUsers } from "react-icons/fa";

export default function AboutPage() {
  return (
    <>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#055862] to-[#ff7a00] text-white py-20 px-6">
        <div className="container mx-auto max-w-6xl grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl font-bold leading-snug mb-4">A Pioneer with Innovative Character</h1>
            <p className="text-white/90 mb-6 text-lg">
              Incorporated in 1980, Informatics is an early pioneer in the business of e-Information in India.
              As a pre-Internet online information service provider, we’ve been instrumental in shaping the
              digital content landscape of Indian academia for over four decades.
            </p>
            <p className="text-white/90 text-lg">
              With a qualified team and deep industry experience, we deliver high-quality, locally relevant
              and globally competitive information services — enriching knowledge communities around the world.
            </p>
          </div>
          <div>
            <img
              src="/informatics.jpg"
              alt="Informatics Team"
              className="rounded-2xl shadow-2xl border-4 border-white max-w-md"
            />
          </div>
        </div>
      </section>

      {/* Vision + Business */}
      <section className="relative py-16 px-6 bg-gradient-to-r from-[#fdfdfd] to-[#eef5f9] overflow-hidden">
      {/* Decorative Background Bubbles */}
    <div className="absolute -top-16 -left-16 w-96 h-96 bg-[#ff7a00]/10 rounded-full blur-3xl z-0"></div>
    <div className="absolute top-1/3 left-1/2 w-72 h-72 bg-[#055862]/10 rounded-full blur-2xl z-0"></div>
    <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff7a00]/20 rounded-full blur-3xl z-0"></div>
    
        <div className="container mx-auto max-w-5xl text-center">
          <h2 className="text-3xl font-bold text-[#055862] mb-10">Our Mission & Vision</h2>
          <div className="grid md:grid-cols-2 gap-10 text-left">
            <div>
              <h3 className="text-xl font-semibold text-[#ff7a00] mb-2 underline">Our Business</h3>
              <p className="text-gray-700 text-lg">
                We work with information and knowledge to create measurable value for our customers —
                enabling smarter education, informed research, and meaningful publishing.
              </p>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-[#ff7a00] mb-2 underline">Our Vision</h3>
              <p className="text-gray-700 text-lg">
                To be a leading global player in the field of information management and digital publishing,
                committed to delivering excellence and innovation in every service we offer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="bg-gray-50 py-20 px-6">
        <div className="container mx-auto max-w-6xl text-center">
          <h2 className="text-3xl font-bold text-[#055862] mb-12">Our Core Values</h2>
          <div className="grid md:grid-cols-3 gap-8 text-left">
            {[
              {
                icon: <FaShieldAlt />,
                title: "Dignity & Integrity",
                desc: "We conduct all business with honesty, transparency, and a strong moral compass."
              },
              {
                icon: <FaLightbulb />,
                title: "Innovation Culture",
                desc: "We empower our teams to be creative, adaptive, and forward-thinking in everything they do."
              },
              {
                icon: <FaUsers />,
                title: "Customer-Centric",
                desc: "We are passionately committed to delivering solutions that exceed client expectations."
              },
              {
                icon: <FaAward />,
                title: "Excellence-Driven",
                desc: "We hold ourselves to the highest standards of quality, accountability, and performance."
              },
              {
                icon: <FaHandshake />,
                title: "Compliance & Trust",
                desc: "We operate with zero-tolerance for statutory non-compliance and protect institutional trust."
              }
            ].map((val, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow hover:shadow-md transition-all">
                <div className="text-[#ff7a00] text-3xl mb-4">{val.icon}</div>
                <h4 className="font-bold text-xl text-[#055862] mb-2">{val.title}</h4>
                <p className="text-gray-600">{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
